import { LicenseCode, Region } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

export const getSchema = (t: TFunction) =>
  z
    .object({
      code: z.enum(LicenseCode),
      region: z.enum(Region),
      isUsingPrivateWallet: z.boolean().optional(),
      walletAddress: z.string().optional(),
    })
    .refine(
      (data) => {
        // If isUsingPrivateWallet is checked, walletAddress must not be empty
        return (
          !data.isUsingPrivateWallet ||
          (data.walletAddress && data.walletAddress.trim().length > 0)
        );
      },
      {
        message: t(Resources.Validation.WalletAddress),
        path: ["walletAddress"],
      },
    );

export type LicenseSelectionModel = z.infer<ReturnType<typeof getSchema>> & {
  couponCode?: string | null;
};
